import React, { FC } from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import theme from 'theme'
import ThemeButton from 'ui/components/buttons/theme/Button'

interface FilterLimitErrorModalProps {
  open: boolean
  onClose: () => void
  columnName: string
  actualCount: number
  limit: number
}

const StyledDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    backgroundColor: theme.colors.surfaceContainerBackground,
    padding: `${theme.spacing.large}px`,
    width: '664px',
    minHeight: '270px',
    borderRadius: theme.attributes.borderRadius.tertiary,
    display: 'flex',
    flexDirection: 'column',
    gap: `${theme.spacing.medium}px`
  }
}))

const StyledDialogTitle = styled(DialogTitle)(() => ({
  color: theme.colors.neutral,
  fontSize: theme.typography.fontSize.xxxxLarge,
  fontWeight: theme.typography.fontWeight.bold,
  fontFamily: theme.typography.fontFamily.primary,
  lineHeight: '42px',
  textAlign: 'center'
}))

const StyledDialogContent = styled(DialogContent)(() => ({
  color: theme.colors.devicesSecondaryText,
  fontSize: theme.typography.fontSize.large,
  fontWeight: theme.typography.fontWeight.normal,
  fontFamily: theme.typography.fontFamily.primary,
  lineHeight: '22px',
  textAlign: 'center',
  padding: 0,

  '.MuiTypography-root': {
    color: theme.colors.devicesSecondaryText,
    fontSize: theme.typography.fontSize.large,
    fontWeight: theme.typography.fontWeight.normal,
    fontFamily: theme.typography.fontFamily.primary,
    lineHeight: '22px',
    textAlign: 'center'
  }
}))

const StyledDialogActions = styled(DialogActions)(() => ({
  padding: '0',
  justifyContent: 'center',
  marginTop: `${theme.spacing.medium}px`
}))

export const FilterLimitErrorModal: FC<FilterLimitErrorModalProps> = ({
  open,
  onClose,
  columnName,
  actualCount,
  limit
}) => {
  return (
    <StyledDialog open={open} onClose={onClose}>
      <StyledDialogTitle sx={{ p: 0 }}>Filter Limit Exceeded</StyledDialogTitle>

      <StyledDialogContent>
        <Typography>
          Too many filter values selected for <strong>{columnName}</strong> ({actualCount} selected).
          <br />
          Please reduce your selection to {limit} or fewer items.
        </Typography>
      </StyledDialogContent>

      <StyledDialogActions>
        <ThemeButton onClick={onClose} sx={{ minWidth: '296px' }}>
          OK
        </ThemeButton>
      </StyledDialogActions>
    </StyledDialog>
  )
}
